import React from 'react';
import { Icon, IconComponentProps } from '../icon/icon';

export function UserCircleIcon(props: IconComponentProps) {
  return (
    <Icon {...props}>
      <svg viewBox="1 1 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M27.0002 3.24854C23.88 3.24854 20.7904 3.86311 17.9077 5.05716C15.025 6.25121 12.4057 8.00136 10.1994 10.2077C7.99306 12.414 6.24291 15.0333 5.04886 17.916C3.8548 20.7987 3.24023 23.8883 3.24023 27.0085C3.24023 30.1287 3.8548 33.2184 5.04886 36.1011C6.24291 38.9838 7.99306 41.6031 10.1994 43.8094C12.4057 46.0157 15.025 47.7659 17.9077 48.9599C20.7904 50.154 23.88 50.7685 27.0002 50.7685C30.1204 50.7685 33.2101 50.154 36.0928 48.9599C38.9755 47.7659 41.5948 46.0157 43.8011 43.8094C46.0074 41.6031 47.7576 38.9838 48.9516 36.1011C50.1457 33.2184 50.7602 30.1287 50.7602 27.0085C50.7602 23.8883 50.1457 20.7987 48.9516 17.916C47.7576 15.0333 46.0074 12.414 43.8011 10.2077C41.5948 8.00136 38.9755 6.25121 36.0928 5.05716C33.2101 3.86311 30.1204 3.24854 27.0002 3.24854V3.24854Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M43.1998 44.2802C39.5235 41.0143 32.6709 41.0165 31.4192 37.6479C31.2744 36.0528 31.3306 34.9382 31.3306 33.4802C32.0531 33.1011 33.8124 30.6117 34.0306 28.5684C34.5987 28.5219 35.4951 27.9679 35.7575 25.7787C35.899 24.6037 35.3363 23.9427 34.994 23.7343C35.9184 20.9533 37.8387 12.35 31.4418 11.4612C30.783 10.3056 29.0972 9.72021 26.9069 9.72021C18.1416 9.88113 17.0843 16.3395 19.0056 23.7343C18.6644 23.9417 18.1017 24.6037 18.2421 25.7787C18.5056 27.9679 19.3998 28.5219 19.969 28.5684C20.1872 30.6096 21.9454 33.1011 22.6701 33.4802C22.6701 34.9382 22.7241 36.0528 22.5804 37.6479C21.3309 41.0046 14.4988 41.0435 10.7998 44.2802"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </svg>
    </Icon>
  );
}
